"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLookupEntityField = exports.getContainsCodes = exports.parseIdsIfString = void 0;
var traverseGetData_1 = __importDefault(require("../../../viewConfigSchema/traverseGetData"));
var parseIdsIfString = function (ids) {
    if (typeof ids === 'string' && ids[0] === '[') {
        return JSON.parse(ids);
    }
    return ids;
};
exports.parseIdsIfString = parseIdsIfString;
var getContainsCodes = function (concepts) { return function (ids) {
    var codes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        codes[_i - 1] = arguments[_i];
    }
    var conceptsByCode = Object.assign.apply(Object, __spreadArray([{}], ((0, exports.parseIdsIfString)(ids) || []).flatMap(function (id) {
        var _a;
        return concepts[id] && concepts[id].code ? [(_a = {}, _a[concepts[id].code] = concepts[id], _a)] : [];
    }), false));
    return !codes.find(function (c) { return !conceptsByCode[c]; }); // the codes were all found
}; };
exports.getContainsCodes = getContainsCodes;
var getLookupEntityField = function (viewConfig, entities) {
    var lookupEntityData = function (entityType, id, expression) {
        if (id === 'null' || id === '') {
            // for convenience in printTemplate templating.
            return null;
        }
        return (0, traverseGetData_1.default)(viewConfig, expression, {
            id: id,
            entityType: entityType,
        }, entities).fold(null, function (value) { return (typeof value !== 'undefined' ? value : null); });
    };
    return lookupEntityData;
};
exports.getLookupEntityField = getLookupEntityField;
//# sourceMappingURL=index.js.map